import { render, staticRenderFns } from "./SnoozeModal.vue?vue&type=template&id=5fa83998&scoped=true&"
import script from "./SnoozeModal.vue?vue&type=script&lang=js&"
export * from "./SnoozeModal.vue?vue&type=script&lang=js&"
import style0 from "./SnoozeModal.vue?vue&type=style&index=0&id=5fa83998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa83998",
  null
  
)

export default component.exports